import { render, staticRenderFns } from "./OrdersDashboard.vue?vue&type=template&id=d05840e8&scoped=true&"
import script from "./OrdersDashboard.vue?vue&type=script&lang=js&"
export * from "./OrdersDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OrdersDashboard.vue?vue&type=style&index=0&id=d05840e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05840e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d05840e8')) {
      api.createRecord('d05840e8', component.options)
    } else {
      api.reload('d05840e8', component.options)
    }
    module.hot.accept("./OrdersDashboard.vue?vue&type=template&id=d05840e8&scoped=true&", function () {
      api.rerender('d05840e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Orders/components/OrdersDashboard.vue"
export default component.exports